<div class="d-flex">
    <div class="left">
        <!-- Logo -->
        <div class="logo-text text-center pt-4 px-4">JoyFlix</div>        
        <div class="p-4">
            <div class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
                <div class="form-group mb-0">
                    <div class="input-group input-group-alternative">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fas fa-search"></i>
                            </span>
                        </div>
                        <input class="form-control" placeholder="Search a movie..." type="text" [(ngModel)]="searchString" (ngModelChange)="searchTerm$.next($event)">
                    </div>
                </div>
            </div>
            
        </div>
        <!-- Movie lists -->
        <div class="movie-list">
            <ul>
                <li class="px-4 py-3" *ngFor="let movie of movieList;let i = index;" (click)="selectMovie(movie?.imdbID)" [ngClass]="{'active': selectedId === movie?.imdbID}">{{ movie?.Title }}</li>
            </ul>
        </div>  
        <!-- Pagination -->    
        <ngb-pagination [collectionSize]="pageLength" [(page)]="pageNumber" (pageChange)="selectPage($event)" [boundaryLinks]="true">
            <ul class="pagination">
                <ng-template ngbPaginationPages let-page let-pages="pages">
                    <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                        <div class="form-group flex-nowrap px-2">
                          <h5 class="card-title text-uppercase text-muted mb-0 mt-2">Page {{ pageNumber }}</h5>
                          <p class="mb-0 text-muted text-sm">{{ totalResults }} results</p>
                        </div>
                    </li>
                </ng-template>
            </ul>            
        </ngb-pagination>  
    </div>
    <div class="right p-4">
        <div class="d-flex">
            <div class="p-4 col-lg-8 col-md-7">
                <h1>{{ selectedMovie?.Title }}</h1>
                <h5 class="card-title text-uppercase text-muted mb-5">{{ selectedMovie?.Genre }}</h5>
                <p>{{ selectedMovie?.Plot }}</p>
                <p class="mt-3 mb-0 text-muted text-sm">Language: {{ selectedMovie?.Language }}</p>
                <p class="mb-0 text-muted text-sm">Director: {{ selectedMovie?.Director }}</p>
                <p class="mb-0 text-muted text-sm">Actors: {{ selectedMovie?.Actors }}</p>
                <p class="mb-0 text-sm text-success">{{ selectedMovie?.Runtime }}</p>
                <hr>
                <p class="mb-0 text-muted text-sm">Awards: {{ selectedMovie?.Awards }}</p>
                <p class="mb-0 text-muted text-sm">BoxOffice: {{ selectedMovie?.BoxOffice }}</p>
                <p class="mb-0 text-muted text-sm">Country: {{ selectedMovie?.Country }}</p>
                <p class="mb-0 text-muted text-sm">DVD: {{ selectedMovie?.DVD }}</p>
                <p class="mb-0 text-muted text-sm">Production: {{ selectedMovie?.Production }}</p>
                <p class="mb-0 text-muted text-sm">Released: {{ selectedMovie?.Released }}</p>
                <h1 class="imbdb-rating mt-5 mb-0">{{ selectedMovie?.imdbRating !== 'N/A' ? (getPercentage(selectedMovie?.imdbRating) + '%') : 'N/A' }}</h1>
                <p class="mb-0 text-muted text-sm">{{ selectedMovie?.imdbVotes !== 'N/A' ? (selectedMovie?.imdbVotes + 'votes') : 'N/A' }}</p>
            </div>
            <div class="p-4 col-lg-4 col-md-5 text-center">
                <div class="poster mb-5" [ngStyle]="{'background-image': 'url(' + selectedMovie?.Poster + ')'}"></div>
                <button type="button" class="btn-watch btn btn-primary btn-lg btn-block" (click)="watch(selectedMovie?.Title)">Watch Now</button>
            </div>
        </div>
    </div>
</div>